var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file [Please Input File Description]
 * @author (zhuwanying02) if any problem, please call me.
 */

import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './Navbar.less';
import { classPrefix, isIE } from '../../common/util';

/* global window getComputedStyle*/

/*
 *  参数说明
 *  themeColor   可选，默认背景色透明。目前仅支持白色背景+cb色字体，值为'white-cb'
 *
 */

var Navbar = function (_Component) {
    _inherits(Navbar, _Component);

    function Navbar(props) {
        _classCallCheck(this, Navbar);

        var _this = _possibleConstructorReturn(this, (Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call(this, props));

        _this.getIsShowButtonValue = function () {
            // 先变回初始状态判断宽度，再决定展示类型
            _this.setState({ miniType: false }, function () {
                var innerWidth = parseFloat(window.innerWidth);
                var WIDTH_RESPONSIVE = _this.WIDTH_RESPONSIVE;
                var containerWidth = void 0;
                var childrenWidth = 0;
                if (isIE()) {
                    // ie11 h获取width不同的问题
                    containerWidth = parseFloat(getComputedStyle(_this.nav).width);
                } else {
                    containerWidth = parseFloat(getComputedStyle(_this.nav).width) - parseFloat(getComputedStyle(_this.nav).paddingLeft) - parseFloat(getComputedStyle(_this.nav).paddingRight);
                }

                for (var i = 0; i < _this.nav.children.length; i++) {
                    var style = getComputedStyle(_this.nav.children[i]);
                    childrenWidth += parseFloat(style.marginLeft) + parseFloat(style.marginRight) + parseFloat(style.width);
                }

                if (innerWidth <= WIDTH_RESPONSIVE) {
                    _this.setState({ miniType: true });
                } else if (containerWidth < childrenWidth) {
                    _this.setState({ miniType: true });
                } else {
                    _this.setState({ miniType: false });
                }
            });
        };

        _this.state = {
            miniType: false
        };
        _this.WIDTH_RESPONSIVE = 800;
        return _this;
    }

    _createClass(Navbar, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                responsive: this.props.responsive,
                miniType: this.state.miniType
            };
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.responsive) {
                this.getIsShowButtonValue();
                window.addEventListener('resize', this.getIsShowButtonValue);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.responsive) {
                window.removeEventListener('resize', this.getIsShowButtonValue);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _this2 = this;

            var _props = this.props,
                className = _props.className,
                children = _props.children,
                themeColor = _props.themeColor,
                dropdown = _props.dropdown,
                classPrefix = _props.classPrefix,
                fixed = _props.fixed,
                responsive = _props.responsive,
                attributes = _objectWithoutProperties(_props, ['className', 'children', 'themeColor', 'dropdown', 'classPrefix', 'fixed', 'responsive']);

            var cx = classnames(className, (_classnames = {}, _defineProperty(_classnames, classPrefix + '-navbar-root', true), _defineProperty(_classnames, 'theme-white-cb', themeColor === 'white-cb'), _defineProperty(_classnames, 'theme-cbd-white', themeColor === 'cbd-white'), _defineProperty(_classnames, 'area-dropdown', dropdown === 'area'), _defineProperty(_classnames, 'nav-fixed', fixed), _defineProperty(_classnames, 'responsive', responsive), _defineProperty(_classnames, 'mini-type', this.state.miniType), _classnames));

            return React.createElement(
                'div',
                _extends({ className: cx }, attributes, { ref: function ref(el) {
                        _this2.nav = el;
                    } }),
                children
            );
        }
    }]);

    return Navbar;
}(Component);

Navbar.propTypes = {
    className: PropTypes.string,
    dropdown: PropTypes.string,
    themeColor: PropTypes.string,
    children: PropTypes.node,
    classPrefix: PropTypes.string,
    fixed: PropTypes.bool,
    responsive: PropTypes.bool
};
Navbar.defaultProps = {
    classPrefix: classPrefix
};
Navbar.childContextTypes = {
    responsive: PropTypes.bool,
    miniType: PropTypes.bool
};
export default Navbar;